<template>
  <div class="page-wrapper">
    <div id="main-page">
      <section id="home" data-anchor="page1" class="section fp-auto-height">
        <div class="home">
          <header>
            <nav class="navigation navbar navbar-default">
              <div class="container">
                <div class="navbar-header">
                  <a class="navbar-brand" href="https://xidong360.com">
                    <img
                      src="https://scdn.xidong360.com/newhome/images/footer-xdlogo.png"
                      class="xdlogo"
                      alt
                      height="38"
                    />
                  </a>
                </div>
                <div id="navbar" class="navbar-collapse collapse navbar-right">
                  <ul class="nav navbar-nav">
                    <li class="isNav active">
                      <a href="#home" title="首页">HOME</a>
                    </li>
                    <li class="isNav">
                      <a href="#services" title="产品与服务">产品与服务</a>
                    </li>
                    <li class="isNav">
                      <a href="#zoology" title="产业生态">产业生态</a>
                    </li>
                    <li class="isNav">
                      <a href="#projects" title="喜动观察">喜动观察</a>
                    </li>
                    <li class="isNav">
                      <a href="#about" title="联系我们">联系我们</a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </header>
          <div class="home-wrapper">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  style="
                    background-image: url(https://scdn.xidong360.com/newhome/images/web/swiper1.png);
                    background-repeat: no-repeat;
                    background-position: center center;
                  "
                >
                  <div class="container">
                    <div class="img-slogan">
                      <div class="bigslogan">科技+体育 为运营赋能</div>
                      <img
                        src="https://scdn.xidong360.com/newhome/images/web/xidong.png"
                      />
                    </div>
                    <div class="slogan">
                      <div class="title">· 喜动 · 2019国际乒联世界巡回赛</div>
                      <div class="content">
                        看喜动为国际顶级大赛提供的品牌服务。从视觉到传播，从权益到新媒体，在先进的IT管理系统的帮助下，大跨度考验整体运营能力。
                      </div>
                    </div>
                    <div class="operate">
                      <a>了解详情</a>
                    </div>
                  </div>
                </div>
                <div
                  class="swiper-slide"
                  style="
                    background-image: url(https://scdn.xidong360.com/newhome/images/web/swiper2.png);
                    background-repeat: no-repeat;
                    background-position: center center;
                  "
                >
                  <div class="container">
                    <div class="img-slogan">
                      <div class="bigslogan">科技+体育 为园区赋能</div>
                      <img
                        src="https://scdn.xidong360.com/newhome/images/web/xidong.png"
                      />
                    </div>
                    <div class="slogan">
                      <div class="title">· 喜动 · 双鹤湖定向运动主题公园</div>
                      <div class="content">
                        看喜动如何破解政府公益公园的运营困境。将静态的风景场景化、游戏化、故事化，手机
                        <br />配合智能基站，定向运动全天候为游客和园区提供服务。畅游畅玩，定向公园。
                      </div>
                    </div>
                    <div class="operate">
                      <a>了解详情</a>
                    </div>
                  </div>
                </div>
                <div
                  class="swiper-slide"
                  style="
                    background-image: url(https://scdn.xidong360.com/newhome/images/web/swiper3.png);
                    background-repeat: no-repeat;
                    background-position: center center;
                  "
                >
                  <div class="container">
                    <div class="img-slogan">
                      <div class="bigslogan">科技+体育 为品牌赋能</div>
                      <img
                        src="https://scdn.xidong360.com/newhome/images/web/xidong.png"
                      />
                    </div>
                    <div class="slogan">
                      <div class="title">
                        · 喜动 · 平顶山银行国球文化数字中心
                      </div>
                      <div class="content">
                        看喜动如何破解政府公益公园的运营困境。将静态的风景场景化、游戏化、故事化，手机
                        <br />配合智能基站，定向运动全天候为游客和园区提供服务。畅游畅玩，定向公园。
                      </div>
                    </div>
                    <div class="operate">
                      <a>了解详情</a>
                    </div>
                  </div>
                </div>
                <div
                  class="swiper-slide"
                  style="
                    background-image: url(https://scdn.xidong360.com/newhome/images/web/swiper4.png);
                    background-repeat: no-repeat;
                    background-position: center center;
                  "
                >
                  <div class="container">
                    <div class="img-slogan">
                      <div class="bigslogan">科技+体育 为管理赋能</div>
                      <img
                        src="https://scdn.xidong360.com/newhome/images/web/xidong.png"
                      />
                    </div>
                    <div class="slogan">
                      <div class="title">
                        · 喜动 · 河南社体——全民健身公共服务平台
                      </div>
                      <div class="content">
                        受河南社体委托，喜动构建和运营了全民健身公共服务平台，群众如何方便获取全民健身赛事
                        <br />？赛事如何方便组织群众参与？政府如何对赛事执行效果全程评价？平台的意义就在于此。
                      </div>
                    </div>
                    <div class="operate">
                      <a>了解详情</a>
                    </div>
                  </div>
                </div>
                <div
                  class="swiper-slide"
                  style="
                    background-image: url(https://scdn.xidong360.com/newhome/images/web/swiper5.png);
                    background-repeat: no-repeat;
                    background-position: center center;
                  "
                >
                  <div class="container">
                    <div class="img-slogan">
                      <div class="bigslogan">科技+体育 为决策赋能</div>
                      <img
                        src="https://scdn.xidong360.com/newhome/images/web/xidong.png"
                      />
                    </div>
                    <div class="slogan">
                      <div class="title">
                        · 喜动 · 平顶山银行国球文化数字中心
                      </div>
                      <div class="content">
                        看喜动如何破解政府公益公园的运营困境。将静态的风景场景化、游戏化、故事化，手机
                        <br />配合智能基站，定向运动全天候为游客和园区提供服务。畅游畅玩，定向公园。
                      </div>
                    </div>
                    <div class="operate">
                      <a>了解详情</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </section>
      <section id="services" data-anchor="page2" class="section">
        <div class="services">
          <div class="head-title">
            <div class="cn-title">产品与服务</div>
            <div class="en-title">Our Services</div>
          </div>
          <div class="service-wrapper">
            <div class="container">
              <div class="service-content">
                <div class="service-item">
                  <img
                    src="https://scdn.xidong360.com/newhome/images/web/service1.png"
                  />
                  <h4>运营服务</h4>
                  <div class="content">
                    <div class="info">
                      基于对体育的理解和长久实践经验，以
                      大数据为依托，为商业机构、景区、社
                      区、全民健身活动提供从策划到包装到
                      运营的一站式全案运营服务，让你的业
                      务声量更大，传播更有效。
                    </div>
                    <div class="op">
                      <a href>了解详情</a>
                      <span class="glyphicon glyphicon-plus"></span>
                    </div>
                  </div>
                </div>
                <div class="service-item">
                  <img
                    src="https://scdn.xidong360.com/newhome/images/web/service2.png"
                  />
                  <h4>数据决策服务</h4>
                  <div class="content">
                    <div class="info">
                      得益于喜动自主构建的运动链服务，为
                      政府、商业机构提供运动人群数据分析
                      和决策服务，帮助客户更精准了解目标
                      用户，从而提供有效的个性化服务，提 升客户体验。
                    </div>
                    <div class="op">
                      <a href>了解详情</a>
                      <span class="glyphicon glyphicon-plus"></span>
                    </div>
                  </div>
                </div>
                <div class="service-item">
                  <img
                    src="https://scdn.xidong360.com/newhome/images/web/service3.png"
                  />
                  <h4>赛事信息化服务</h4>
                  <div class="content">
                    <div class="info">
                      被广泛深度使用的赛事服务系统，只需
                      极低的成本，即可获得被数百次验证的
                      赛事标准化模型。没有经验也能办赛，
                      出世即高手；经验丰富办赛更精彩，高 手不寂寞。
                    </div>
                    <div class="op">
                      <a href>了解详情</a>
                      <span class="glyphicon glyphicon-plus"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="zoology" data-anchor="page3" class="section">
        <div class="zoology">
          <div class="container">
            <div class="slogan">
              <div class="title">· 喜动 · 体育产业生态</div>
              <div class="content">
                河南喜动体育科技有限公司（简称：喜动）成立于2016年9月，致力于为体育行业提供基于移动互
                联网和大数据的信息化解决方案。
              </div>
            </div>
            <div class="operate">
              <a href>了解详情</a>
            </div>
          </div>
        </div>
      </section>
      <section id="projects" data-anchor="page4" class="section">
        <div class="container projectsMain">
          <div class="projects">
            <div class="projects-item">
              <img
                src="https://scdn.xidong360.com/ssy/web/projects-4.jpg"
                width="100%"
              />
              <h4>
                [ 广场舞 ] 如何保证
                <br />各年龄层的用户都能顺畅使用？
              </h4>
              <div class="content">
                <div class="info">
                  被广泛深度使用的赛事服务系统，只需极低的
                  成本，即可获得被数百次验证的赛事标准化模
                  型。没有经验也能办赛，出世即高手；经验丰
                </div>
                <div class="op">
                  <a href>展开阅读</a>
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="projects-item">
              <img
                src="https://scdn.xidong360.com/ssy/web/projects-1.jpg"
                width="100%"
              />
              <h4>
                [ 赛事运营 ] 中国农业银行
                <br />2019 国际乒联世界巡回赛总决赛
              </h4>
              <div class="content">
                <div class="info">
                  被广泛深度使用的赛事服务系统，只需极低的
                  成本，即可获得被数百次验证的赛事标准化模
                  型。没有经验也能办赛，出世即高手；经验丰
                </div>
                <div class="op">
                  <a href>展开阅读</a>
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="projects-item">
              <img
                src="https://scdn.xidong360.com/ssy/web/projects-2.jpg"
                width="100%"
              />
              <h4>
                [ 赛事运营 ] 2019 中国乒乓球协会
                <br />会员联赛总决赛
              </h4>
              <div class="content">
                <div class="info">
                  被广泛深度使用的赛事服务系统，只需极低的
                  成本，即可获得被数百次验证的赛事标准化模
                  型。没有经验也能办赛，出世即高手；经验丰
                </div>
                <div class="op">
                  <a href>展开阅读</a>
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="projects-item">
              <img
                src="https://scdn.xidong360.com/ssy/web/projects-5.jpg"
                width="100%"
              />
              <h4>
                [ 赛事运营 ] 龙马如意
                <br />2019 郑州龙湖国际半程马拉松
              </h4>
              <div class="content">
                <div class="info">
                  被广泛深度使用的赛事服务系统，只需极低的
                  成本，即可获得被数百次验证的赛事标准化模
                  型。没有经验也能办赛，出世即高手；经验丰
                </div>
                <div class="op">
                  <a href>展开阅读</a>
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="projects-item">
              <img
                src="https://scdn.xidong360.com/ssy/web/projects-3.jpg"
                width="100%"
              />
              <h4>
                [ 赛事运营 ] 郑州坐标
                <br />第五届河南省城市坐标定向赛
              </h4>
              <div class="content">
                <div class="info">
                  被广泛深度使用的赛事服务系统，只需极低的
                  成本，即可获得被数百次验证的赛事标准化模
                  型。没有经验也能办赛，出世即高手；经验丰
                </div>
                <div class="op">
                  <a href>展开阅读</a>
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="projects-item">
              <img
                src="https://scdn.xidong360.com/ssy/web/projects-6.jpg"
                width="100%"
              />
              <h4>
                [ 赛事运营 ]
                <br />2019 全民体质达标测试赛
              </h4>
              <div class="content">
                <div class="info">
                  被广泛深度使用的赛事服务系统，只需极低的
                  成本，即可获得被数百次验证的赛事标准化模
                  型。没有经验也能办赛，出世即高手；经验丰
                </div>
                <div class="op">
                  <a href>展开阅读</a>
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="operate">
            <a href>展开更多</a>
          </div>
        </div>
      </section>
      <section id="about" data-anchor="page5" class="section">
        <div class="about">
          <div class="container">
            <div class="about-content">
              <div class="contact-info">
                <h2>联系我们</h2>
                <p class="xd">
                  河南喜动体育科技有限公司是一家致力于提供全周期互联网赛事活动支撑方案，运动场馆物联网建设与服务，运动人群大数据聚合分析与处理的专业体育平台运营公司。
                </p>
                <div class="info-1">
                  <p class="title">发起股东：河南大河搏冠体育产业有限公司</p>
                  <div class="content">
                    河南知名的综合性体育服务供应商。主营业务包括赛事运营、大型场地运营、俱乐部和培训等。股东之一为河南日报报业集团旗下大河传媒有限公司。
                  </div>
                </div>
                <div class="info-1">
                  <p class="title">发起股东：北京点金时代科技有限公司</p>
                  <div class="content">
                    资深增值电信业务服务商，2003年成为中国移动河南有限公司紧密合作伙伴至今。资深移动互联网业务服务商，2008年开始开展移动互联网业务，积累了丰富的运营经验。
                  </div>
                </div>
              </div>
              <div class="contact-map">
                <div class="map"></div>
                <div class="link">
                  <ul>
                    <li>
                      <img
                        src="https://scdn.xidong360.com/newhome/images/web/about1.svg"
                        alt
                      />
                      <p>郑州市金水区平顶山银行大厦19层</p>
                    </li>
                    <li>
                      <img
                        src="https://scdn.xidong360.com/newhome/images/web/about2.svg"
                        alt
                      />
                      <p>400-699-8789 0371-6586-1656</p>
                    </li>
                    <li>
                      <img
                        src="https://scdn.xidong360.com/newhome/images/web/about3.svg"
                        alt
                      />
                      <p>hi@xidong360.com</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
            <div class="row">
              <div class="col col-sm-2 footer-logo-wrapper">
                <img
                  src="https://scdn.xidong360.com/newhome/images/footer-xdlogo.png"
                  alt
                  class="img img-responsive"
                />
              </div>
              <div class="col col-sm-7 copyright-info-wrapper">
                <p class="copyright-info">
                  &copy; Copyright © 2020 河南喜动体育科技有限公司
                  <span>|</span>
                  <a target="_blank" href="https://beian.miit.gov.cn/">
                    {{ ICP }}
                  </a>
                </p>
                <div style="width: 300px; margin: 0 auto; padding: 20px 0">
                  <a
                    target="_blank"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41010502004767"
                    style="
                      display: inline-block;
                      text-decoration: none;
                      height: 20px;
                      line-height: 20px;
                    "
                  >
                    <img
                      src="https://scdn.xidong360.com/gonganbeian.png"
                      style="float: left"
                    />
                    <p
                      style="
                        float: left;
                        height: 20px;
                        line-height: 20px;
                        margin: 0px 0px 0px 5px;
                        color: #939393;
                      "
                    >
                      豫公网安备 41010502004767号
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ICP: "豫ICP备16038234号-1",
    };
  },
  activated() {
    if (window.location.host.indexOf("xidong360.com") > -1) {
      this.ICP = "豫ICP备16038234号-1";
    } else if (window.location.host.indexOf("zztta.cn") > -1) {
      this.ICP = "豫ICP备16038234号-12";
    }
  },
  mounted() {
    if (window.location.host.indexOf("xidong360.com") > -1) {
      this.ICP = "豫ICP备16038234号-1";
    } else if (window.location.host.indexOf("zztta.cn") > -1) {
      this.ICP = "豫ICP备16038234号-12";
    }
    document.title = "喜动-数字科技引领文体创新";
    new window.Swiper(".swiper-container", {
      pagination: ".swiper-pagination",
      paginationClickable: true,
      direction: "vertical",
      width: window.innerWidth,
      height: window.innerHeight,
      autoplay: true,
      autoHeight: true,
      observer: true,
      observeParents: true,
    });
    window.jQuery(".zoology").height(window.innerHeight);
    window.jQuery(".services").height(window.innerHeight);
    // window.jQuery(".projectsMain").height(window.innerHeight);
    window.jQuery(".isNav").on("click", function () {
      window.jQuery(".isNav").removeClass("active");
      window.jQuery(this).addClass("active");
    });
  },
};
</script>